import React from "react";
import { Switch } from "@/components/ui/switch";
import { cn } from "@/lib/utils";

interface StatusToggleProps {
    name: string;
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    checked: boolean;
    disabled?: boolean;
    children: React.ReactNode;
    id?: string;
    index?: number;
}

const StatusToggle: React.FC<StatusToggleProps> = ({ disabled, id, name, checked, onChange, children, index }) => {
    const controlId = id ?? name;

    return (
        <div className="gs-status-toggle">
            <span className="gs-prod-switch-wrap">
                <Switch
                    id={controlId}
                    className="gs-prod-switch"
                    checked={checked}
                    disabled={disabled}
                    onCheckedChange={(val) =>
                        onChange({ target: { checked: val, name } } as React.ChangeEvent<HTMLInputElement>)
                    }
                />
            </span>
            <label
                htmlFor={controlId}
                id={`${index !== undefined ? index : controlId}-toggle-label`}
                className={cn("gs-status-toggle__label", checked ? "active" : "inactive")}
            >
                {children}
            </label>
        </div>
    );
};

export default StatusToggle;
